import { specials } from '@/mocks/chaoyang';
import { formatCount } from './tones';

export default function Specials() {
  return (
    <section id="special" className="scroll-mt-24 bg-[#fff7ec] py-10 md:py-14">
      <div className="chigua-container">
        <div className="flex flex-wrap items-end justify-between gap-3 pb-2">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-red-500/10 px-3 py-1 text-xs font-bold text-red-600 ring-1 ring-red-500/20">
              <i className="ri-sparkling-fill text-sm"></i>
              深度 · 必看专题
            </span>
            <h2 className="mt-3 text-2xl font-black tracking-tight text-stone-900 md:text-3xl">必看专题</h2>
            <p className="mt-1 text-sm text-stone-600">把热点掰开揉碎，多角度记录同一件事，吃瓜也吃个明白。</p>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
          {specials.map((sp) => (
            <article key={sp.id} className="group overflow-hidden rounded-2xl bg-white ring-1 ring-black/5 transition-all hover:-translate-y-1 hover:ring-orange-500/30">
              <div className="relative h-44 overflow-hidden">
                <img src={sp.cover} alt={`专题《${sp.title}》的现场封面图`} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 to-transparent"></div>
                <span className="absolute left-3 top-3 rounded-md bg-white/90 px-2 py-1 text-[11px] font-bold text-orange-700 backdrop-blur-sm">{sp.category}</span>
                <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 rounded-md bg-black/40 px-2 py-1 text-[11px] font-medium text-white backdrop-blur-sm">
                  <i className="ri-eye-line"></i>
                  {formatCount(sp.reads)} 读过
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-black leading-snug text-stone-900 group-hover:text-orange-700">
                  <a href="#special" className="cursor-pointer" onClick={(e) => e.preventDefault()}>
                    {sp.title}
                  </a>
                </h3>
                <p className="mt-2 line-clamp-3 text-[13px] leading-relaxed text-stone-600">{sp.desc}</p>
                <button type="button" className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-orange-600 hover:text-orange-700 cursor-pointer">
                  浏览专题摘要
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}